import FingerprintJS from '@fingerprintjs/fingerprintjs' // 公共方法：格式化数字
import { reportClientError } from '@/utils/clientDiagnostics'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
// 千分位
export function formatNumberWithCommas(value) {
  // #15 守卫:value 为 null/undefined 时,非 BRL 分支 isNaN(null)===false 会漏过,
  // 随后 null.toString() 抛错导致金额区白屏;两分支都把空值当 '' 处理,故在最前置统一守卫。
  if (value === null || value === undefined) return ''
  if (this.getCurrency !== 'BRL') {
    // 如果值为NaN，返回空字符串
    if (isNaN(value)) {
      return ''
    }
    // 将数字转换为字符串
    let num = value.toString()
    // 判断是否包含小数点
    let [integer, decimal] = num.split('.')
    // 对整数部分进行千分位逗号分隔
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    // 拼接整数和小数部分
    return decimal ? `${integer}.${decimal.slice(0, 2)}` : integer
  } else {
    if (!value && value !== 0) return '' // 如果值无效，返回空字符串

    // 将数字转换为字符串
    let stringValue = value.toString()

    // 判断是否为负数
    let isNegative = stringValue.startsWith('-')
    if (isNegative) {
      stringValue = stringValue.slice(1) // 去掉负号
    }

    // 拆分整数部分和小数部分
    let [integerPart, decimalPart = '00'] = stringValue.split('.')
    decimalPart = decimalPart.padEnd(2, '0').slice(0, 2) // 确保小数部分保留两位

    // 添加千分位分隔符
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

    // 如果小数部分是“00”，则不显示小数部分
    let result
    if (decimalPart === '00') {
      result = integerPart
    } else {
      result = `${integerPart},${decimalPart}`
    }

    // 如果是负数，添加负号
    if (isNegative) {
      result = `-${result}`
    }

    return result
  }
}
//uuid
export function generateUUID() {
  // 创建一个 16 字节的数组
  const buffer = new Uint8Array(16)
  // 使用 crypto.getRandomValues 填充随机值
  const cryptoSource = getCryptoSource()
  try {
    if (cryptoSource && typeof cryptoSource.getRandomValues === 'function') {
      cryptoSource.getRandomValues(buffer)
    } else {
      for (let i = 0; i < buffer.length; i += 1) {
        buffer[i] = Math.floor(Math.random() * 256)
      }
    }
  } catch (e) {
    for (let i = 0; i < buffer.length; i += 1) {
      buffer[i] = Math.floor(Math.random() * 256)
    }
  }

  buffer[6] = (buffer[6] & 0x0f) | 0x40
  buffer[8] = (buffer[8] & 0x3f) | 0x80
  const hex = Array.from(buffer, item => item.toString(16).padStart(2, '0'))
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join('')
  ].join('-')
}

function getCryptoSource() {
  try {
    if (typeof crypto !== 'undefined' && crypto) return crypto
  } catch (e) {
    // Fall through to the window fallback.
  }
  try {
    if (typeof window !== 'undefined' && window && window.crypto) return window.crypto
  } catch (e) {
    return null
  }
  return null
}

//指纹uuid
export async function getFingerprint() {
  try {
    // const fp = await FingerprintJS.load()
    // const options = {
    //   excludes: {
    //     screenResolution: true, // 排除屏幕分辨率
    //     fonts: true // 排除字体信息
    //   }
    // }
    // const result = await fp.get(options)
    const fp = await FingerprintJS.load() // 加载 FingerprintJS
    const result = await fp.get() // 获取指纹结果
    return result.visitorId // 返回指纹ID
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      reportClientError(error)
    }
    return null // 如果失败，返回null
  }
}
// 获取当天范围
export function getTodayRange() {
  return (
    this.$dayjs().startOf('day').format('YYYY-MM-DD 00:00:00') +
    '&' +
    this.$dayjs().endOf('day').format('YYYY-MM-DD 23:59:59')
  )
}
// 获取昨天范围
export function getYesterdayRange() {
  return (
    this.$dayjs()
      .subtract(1, 'day')
      .startOf('day')
      .format('YYYY-MM-DD 00:00:00') +
    '&' +
    this.$dayjs().subtract(1, 'day').endOf('day').format('YYYY-MM-DD 23:59:59')
  )
}
// 获取这周范围
export function getThisWeekRange() {
  return (
    this.$dayjs().startOf('week').format('YYYY-MM-DD 00:00:00') +
    '&' +
    this.$dayjs().endOf('week').format('YYYY-MM-DD 23:59:59')
  )
}
// 获取上周范围
export function getLastWeekRange() {
  return (
    this.$dayjs()
      .subtract(1, 'week')
      .startOf('week')
      .format('YYYY-MM-DD 00:00:00') +
    '&' +
    this.$dayjs()
      .subtract(1, 'week')
      .endOf('week')
      .format('YYYY-MM-DD 23:59:59')
  )
}
// 获取这个月范围
export function getThisMonthRange() {
  return (
    this.$dayjs().startOf('month').format('YYYY-MM-DD 00:00:00') +
    '&' +
    this.$dayjs().endOf('month').format('YYYY-MM-DD 23:59:59')
  )
}
// 获取上个月范围
// 上报活动面板的打开/关闭事件
// promoType: sign_daily / lucky_roulette / new_player_giftpack / treasure_box
//            task_newbie / task_daily / task_weekly / red_packet
// eventType: 1=打开面板, 2=关闭面板
export async function reportPromoPanel(promoType, eventType) {
  if (!promoType || !eventType) return
  if (!safeGetStorageItem(safeLocalStorage(), 'token')) return
  try {
    const { ReportPromoPanelEvent } = await import('@/api/common')
    const response = await ReportPromoPanelEvent({ promoType, eventType })
    if (hasUntrackedPromoPanelResponse(response)) return false
  } catch (e) {
    // 静默失败，不影响业务
  }
}

function hasUntrackedPromoPanelResponse(value, depth = 0, seen = []) {
  if (!value || typeof value !== 'object' || depth > 6 || seen.includes(value)) return false
  seen.push(value)
  if (Array.isArray(value)) {
    return value.some(item => hasUntrackedPromoPanelResponse(item, depth + 1, seen))
  }
  if ([value.status, value.state, value.code, value.errorCode].some(isPromoPanelBlockedStatus)) return true
  if (
    isPromoPanelFalseMarker(value.serverTracked) ||
    isPromoPanelFalseMarker(value.writeProof) ||
    isPromoPanelFalseMarker(value.trackingWriteProof)
  ) {
    return true
  }
  if (
    isPromoPanelActiveMarker(value.readOnlyAction) ||
    isPromoPanelActiveMarker(value.writeBlocked) ||
    isPromoPanelActiveMarker(value.backendBlocked) ||
    isPromoPanelActiveMarker(value.backend_blocked) ||
    isPromoPanelActiveMarker(value.backendFailure) ||
    isPromoPanelActiveMarker(value.backend_failure) ||
    isPromoPanelActiveMarker(value.technicalMarker) ||
    isPromoPanelActiveMarker(value.technical_marker) ||
    isPromoPanelActiveMarker(value.technicalError) ||
    isPromoPanelActiveMarker(value.technical_error) ||
    isPromoPanelActiveMarker(value.entryBlocked) ||
    isPromoPanelActiveMarker(value.blocked)
  ) {
    return true
  }
  return [
    'content',
    'data',
    'body',
    'payload',
    'meta',
    'detail',
    'diagnostics',
    'diagnostic'
  ].some(key => hasUntrackedPromoPanelResponse(value[key], depth + 1, seen))
}

function isPromoPanelBlockedStatus(value) {
  const token = String(value === undefined || value === null ? '' : value).trim().toLowerCase()
  return [
    'fail',
    'blocked',
    'write_blocked',
    'backend_failure',
    'backendfailure',
    'technical_marker',
    'technicalmarker',
    'technical_error',
    'technicalerror',
    'read_only',
    'read_only_action',
    'need_login',
    'unavailable'
  ].includes(token)
}

function isPromoPanelActiveMarker(value) {
  if (value === true || value === 1) return true
  const token = String(value === undefined || value === null ? '' : value).trim().toLowerCase()
  return ['true', '1', 'yes', 'on'].includes(token)
}

function isPromoPanelFalseMarker(value) {
  if (value === false || value === 0) return true
  const token = String(value === undefined || value === null ? '' : value).trim().toLowerCase()
  return ['false', '0', 'no', 'off'].includes(token)
}

export function getLastMonthRange() {
  return (
    this.$dayjs()
      .subtract(1, 'month')
      .startOf('month')
      .format('YYYY-MM-DD 00:00:00') +
    '&' +
    this.$dayjs()
      .subtract(1, 'month')
      .endOf('month')
      .format('YYYY-MM-DD 23:59:59')
  )
}
